import { Pipe, PipeTransform } from '@angular/core';

export const NotGroupRawField: Record<string, string> = {
  direction: 'Без БC',
  client: 'Без клиента',
  status: 'Без статуса',
  responsible: 'Без ответственного',
  bankDetails: 'Без р/с',
  taskType: 'Без типа',
  createdBy: 'Без пользователя'
};

@Pipe({
  standalone: true,
  name: 'getValueGroupTable'
})
export class GetValueGroupTablePipe implements PipeTransform {
  public transform(object: any, path: string, field: string = null): any {
    if (!object || !path) {
      return object;
    }

    const pathKeys = path.split('.');
    return pathKeys.reduce((val, key, currentIndex) => {
      if (currentIndex !== pathKeys.length - 1 && typeof val === 'object') {
        return val[key] ?? NotGroupRawField[pathKeys[0]];
      }
      return (field ? val?.[field] : val) ?? NotGroupRawField[pathKeys[0]];
    }, object);
  }
}
